<div id="login-wrapper">
  <div id="login-container">
    <div class="header">
      <div class="language">
        <button type="button" (click)="setLocale('NL')">
          <img src="../../../../assets/images/languages/nl.svg" [alt]="'IMAGE_ALT.FLAG_NL' | translate" />
        </button>
        <button type="button" (click)="setLocale('EN')">
          <img src="../../../../assets/images/languages/gb.svg" [alt]="'IMAGE_ALT.FLAG_GB' | translate" />
        </button>
      </div>

      <div class="logo">
        <img src="../../../assets/organisation/images/logo-auth.svg" [alt]="'IMAGE_ALT.LOGO' | translate" />
      </div>

      <div class="buttons">
        @if (env.QR_LOGIN && !showOTP.value) {
          @switch (application.layout) {
            @case ("mobile") {}
            @case ("mobile-landscape") {}
            @default {
              <button type="button" (click)="toggleQR()">
                <mat-icon [tooltip]="'LOGIN.QR_SWITCH'">{{ showQR.value ? "arrow_back_ios" : "qr_code_scanner" }}</mat-icon>
              </button>
            }
          }
        }
        @if (env.EMAIL_LOGIN && !showOTP.value) {
          @switch (application.layout) {
            @default {
              <button type="button" (click)="toggleEmailLogin()">
                <mat-icon [tooltip]="'LOGIN.EMAIL_SWITCH'">{{ showEmailLogin.value ? "arrow_back_ios" : "email" }}</mat-icon>
              </button>
            }
          }
        }
      </div>
    </div>

    <div class="inner">
      @if (!showEmailLogin.value && !showQR.value && !showOTP.value && !isLoading) {
        <form (submit)="login()">
          <div class="field field-prefix" #usernameRef>
            <label>{{ "LOGIN.USERNAME" | translate }}</label>
            <app-prefix-oms #username [counter]="false" [placeholder]="'LOGIN.USERNAME' | translate" autocomplete="username" />
          </div>

          <div class="field field-prefix" #passwordRef>
            <label>{{ "LOGIN.PASSWORD" | translate }}</label>
            <app-prefix-wac #password [placeholder]="'LOGIN.PASSWORD' | translate" autocomplete="current-password" />
          </div>

          <button type="submit" id="login-button" [disabled]="isLoading">
            {{ "LOGIN.SUBMIT" | translate }}
          </button>

          <div class="link">
            <a [routerLink]="['/recover']">{{ "LOGIN.RECOVER" | translate }}</a>
            @if (env.MSAL) {
              <a [routerLink]="['/login/sso']" [queryParamsHandling]="'preserve'">{{ "LOGIN.SSO" | translate }}</a>
            }
          </div>
        </form>
      }

      @if (showQR.value && !isLoading) {
        <div id="code-container">
          @if (qrcode) {
            <span>{{ "LOGIN.QR_TITLE" | translate }}</span>

            <app-prefix-qrc [value]="qrcode" />
            <div class="timer" [ariaLabel]="'LOGIN.QR_ARIALABEL' | translate">
              <app-timer [ms]="qrIntervalTime" [order]="'DESC'" (onfinish)="generateQR()" type="bar" />
            </div>
          }
        </div>
      }
      @if (showOTP.value && !isLoading) {
        <form (submit)="loginOTP()">
          <div class="field field-prefix" #otpRef>
            <label>{{ "LOGIN.OTP" | translate }}</label>
            <app-prefix-oms #otp [counter]="false" [placeholder]="'LOGIN.OTP' | translate" autocomplete="one-time-code" />
          </div>

          <button type="submit" id="otp-button" [disabled]="isLoading">
            {{ "LOGIN.SUBMIT_OTP" | translate }}
          </button>
        </form>
      }

      @if (showEmailLogin.value && !isLoading) {
        <form (submit)="loginEmail()">
          <div class="field field-prefix">
            <label>{{ "EMAIL_LOGIN.USERNAME" | translate }}</label>
            <app-prefix-oms #username [counter]="false" />
          </div>

          @if (!env.HIDE_PRIVATE_EMAIL_CHECKBOX) {
            <div class="field field-prefix">
              <app-prefix-jan #privateemail [label]="'EMAIL_LOGIN.CHECK' | translate" />
            </div>
          }

          <button type="submit">
            {{ "EMAIL_LOGIN.SUBMIT" | translate }}
          </button>

          @if (isLoading) {
            <div id="loading-container">
              <mat-progress-spinner [color]="'primary'" [diameter]="48" [mode]="'indeterminate'" />
            </div>
          }
        </form>
      }

      @if (isLoading) {
        <div id="loading-container">
          <mat-progress-spinner [color]="'primary'" [diameter]="48" [mode]="'indeterminate'" />
        </div>
      }
    </div>
  </div>
  @if (showNews && news) {
    <div id="news-container">
      <div class="inner" [innerHTML]="news | safeStyle"></div>
    </div>
  }
</div>
